import {inject, Injectable} from '@angular/core';
import {SelectData} from "../../../../../types/records-table.types";
import {DynamicApiService} from "./dynamic-api.service";
import {GetSelectDataParams} from "../types/dynamic.types";

@Injectable({
  providedIn: 'root'
})
export class DynamicService {
  private dynamicApiService: DynamicApiService = inject(DynamicApiService);

  public getSelectData(getSelectDataParams: GetSelectDataParams): Promise<Array<SelectData>> {
    return new Promise((resolve, reject) => {
      this.dynamicApiService.getSelectData(getSelectDataParams).subscribe({
        next: (selectData: Array<SelectData>) => resolve(selectData),
        error: (error) => reject(error)
      });
    });
  }

  public getDefaultSelectDataParams(isProduct: boolean): GetSelectDataParams {
    return  {
      propertyLazySelect: {
        recourseName: 'NoteDto',
        providerType: 'NOTE_PRODUCT_ARTICLE'
      },
      isProduct: isProduct
    };
  }
}
